import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { API_URL, TOKEN } from "../../../variables/constants";
import { toast } from "react-toastify";

const AddBanque = ({
  show,
  handleClose,
  editMode,
  selectedBanque,
  banques,
  onActionComplete, // Nouvelle prop pour indiquer que l'action est terminée
}) => {
  const [loading, setLoading] = useState(false);
  const [nom, setNom] = useState("");

  // Met à jour le champ de nom lorsque le mode d'édition ou la banque sélectionnée change
  useEffect(() => {
    if (editMode && selectedBanque) {
      setNom(selectedBanque.libelleParametre || "");
    } else {
      setNom("");
    }
  }, [editMode, selectedBanque]);

  // Gère la soumission du formulaire (ajout ou modification)
  const onSubmit = (e) => {
    e.preventDefault();

    const nomTrimmed = nom.trim();
    if (!nomTrimmed) {
      toast.warning("Le nom ne peut pas être vide.");
      return;
    }

    // Vérifie si la banque existe déjà (en ignorant l'élément actuel en mode édition)
    const isDuplicate = banques?.some(
      (b) =>
        b.libelleParametre.toLowerCase() === nomTrimmed.toLowerCase() &&
        (!editMode || b.parametreId !== selectedBanque?.parametreId)
    );
    if (isDuplicate) {
      toast.error("Cette banque existe déjà.");
      return;
    }

    setLoading(true);

    // Prépare les données de la banque pour l'API
    const banqueData = {
      ...selectedBanque, // Conserve les autres propriétés en mode édition
      libelleParametre: nomTrimmed,
      typeParametre: "BANQUE",
    };

    // Détermine si c'est une requête PUT (modification) ou POST (ajout)
    const request = editMode
      ? axios.put(`${API_URL}/api/parametre`, banqueData, {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        })
      : axios.post(`${API_URL}/api/parametre`, banqueData, {
          headers: {
            Authorization: `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        });

    request
      .then((res) => {
        toast.success(editMode ? "Banque modifiée avec succès" : "Banque ajoutée avec succès");
        setNom(""); // Réinitialise le champ de nom
        handleClose(); // Ferme la modale

        // Appelle la fonction de rappel pour indiquer que l'action est terminée
        // Le composant parent pourra alors re-fetch les données
        if (onActionComplete) {
          onActionComplete();
        }
      })
      .catch((err) => {
        console.error("Erreur lors de l'enregistrement:", err);
        toast.error("Erreur lors de l'enregistrement de la banque");
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <button
          type="button"
          className="btn-close btn-primary"
          onClick={handleClose}
          aria-label="Close"
        ></button>
        <div className="text-center mb-4">
          <h4>{editMode ? "Modifier la" : "Ajouter une"} banque</h4>
          <p>{editMode ? "Modifier la" : "Ajouter une nouvelle"} banque</p>
        </div>
        <form onSubmit={onSubmit}>
          <div className="mb-3">
            <label className="form-label">Nom de la banque</label>
            <input
              type="text"
              className="form-control"
              placeholder="Nom de la banque"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              required
            />
          </div>
          <div className="text-center">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Enregistrement..." : "Enregistrer"}
            </button>
            <button
              type="button"
              className="btn btn-secondary ms-3"
              onClick={handleClose}
              disabled={loading}
            >
              Annuler
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddBanque;
